import React, { Component } from 'react'
import PropTypes from 'prop-types'
import inView from 'in-view'
import { helpers } from '../../helpers'

/**
* Carousel Component
*
* Child of HeroCarousel Component
*
* Renders and initializes the Owl Carousel component of the Hero Carousel.
*/
class Carousel extends Component {
  constructor(props) {
    super(props)

    this.uid = helpers.generateID('carousel')
    this.carouselSelector = `#${this.uid}`

    // Bind helper methods
    this.trackSlideImpressions = this.trackSlideImpressions.bind(this)

    // Bind callbacks
    this.onTranslated = this.onTranslated.bind(this)
    this.onVisible = this.onVisible.bind(this)
    this.onHidden = this.onHidden.bind(this)
  }

  /**
  * Initializes the owl carousel.
  */
  componentDidMount() {
    $(this.carouselSelector).owlCarousel({
      items: this.props.items,
      loop: this.props.loop,
      autoplay: this.props.autoplay,
      autoplayTimeout: this.props.autoplayTimeout,
      autoplayHoverPause: this.props.autoplayHoverPause,
      lazyLoad: this.props.lazyLoad,
      center: this.props.center,
      nav: this.props.nav,
      navText: this.props.navText,
      dots: this.props.dots,
      mouseDrag: this.props.mouseDrag,
      touchDrag: this.props.touchDrag,
      pullDrag: this.props.pullDrag,
      onTranslated: this.onTranslated,
    })
    // Stop autoplay so it can be triggered when visible.
      .trigger('stop.owl.autoplay')

    // Autoplay carousel only when it is in the viewport, otherwise pause it.
    inView(this.carouselSelector)
      .on('enter', this.onVisible)
      .on('exit', this.onHidden)
  }

  /**
  * Grabs the current slide(s) and tracks slide impressions if appropriate. Only
  * tracks once per page load.
  */
  trackSlideImpressions() {
    const slides = document.querySelector(`${this.carouselSelector} .owl-item.active:not(.cloned)`)


    const $trackable = $(slides).find('a[data-promo-trackable="true"]:not([data-tracking-processed])')

    if (!$trackable.length || $trackable.data('tracking-processed')) {
      return
    }

    $.track('promo impression', {
      id: $trackable.data('promoId'),
      name: $trackable.data('promoName'),
      creative: $trackable.data('promoCreative'),
      position: $trackable.data('promoPosition'),
    })
    $trackable.data('tracking-processed', true)
  }

  /**
  * Wrapper for `onTranslated` prop callback. Only executes `onTranslated` if
  * the carousel is in the viewport.
  */
  onTranslated() {
    if (inView.is(document.querySelector(this.carouselSelector))) {
      this.trackSlideImpressions()
    }
  }

  /**
  * Tracks slide impression(s) and if the `autoplay` prop is set, this will also
  * trigger to carousel to begin autoplaying as long as it's in the viewport.
  */
  onVisible() {
    this.trackSlideImpressions()

    if (this.props.autoplay) {
      $(this.carouselSelector).trigger('play.owl.autoplay')
    }
  }

  /**
  * If the `autoplay` prop is set, then this will pause the carousel while it
  * is no longer in the viewport.
  */
  onHidden() {
    if (this.props.autoplay) {
      $(this.carouselSelector).trigger('stop.owl.autoplay')
    }
  }

  render() {
    return (
      <div className="owl-carousel" id={this.uid}>
        { this.props.children }
      </div>
    )
  }
}

Carousel.defaultProps = {
  autoplay: false,
  autoplayTimeout: 5000,
  autoplayHoverPause: false,
  center: false,
  dots: true,
  items: 1,
  loop: false,
  lazyLoad: false,
  nav: false,
  mouseDrag: true,
  touchDrag: true,
  pullDrag: true,
  navText: [
    '<svg viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" class="db-svg-icon is-chevron-left"><g><path d="M13.295,24l1.41,-2.82l-4.58,-9.18l4.58,-9.18l-1.41,-2.82l-6,12l6,12Z"/></g></svg>',
    '<svg viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" class="db-svg-icon is-chevron-right"><g><path d="M10.705,0l-1.41,2.82l4.58,9.18l-4.58,9.18l1.41,2.82l6,-12l-6,-12Z"/></g></svg>',
  ],
}

Carousel.propTypes = {
  autoplay: PropTypes.bool,
  autoplayTimeout: PropTypes.number,
  autoplayHoverPause: PropTypes.bool,
  center: PropTypes.bool,
  dots: PropTypes.bool,
  items: PropTypes.number,
  loop: PropTypes.bool,
  lazyLoad: PropTypes.bool,
  nav: PropTypes.bool,
  navText: PropTypes.array,
  mouseDrag: PropTypes.bool,
  touchDrag: PropTypes.bool,
  pullDrag: PropTypes.bool,
}

export default Carousel
